// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGridGetBody = {
  poolId: string;
  gridId: string;
  eventId?: string | null;
};

export type typeSquaresGridGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    grid: {
      gridId: string;
      squaresSeasonId: string;
      sequence: number;
      label: string;
      gridType: "classic" | "shared";
      origin: "setup" | "rule" | "manual";
      publishStatus: "draft" | "published";
      gridState: "open" | "locked" | "live" | "final" | "void";
      size: number;
      rowCount: number;
      colCount: number;
      axes: {
        kind:
          "teamNames" | "winnerLoser" | "homeAway" | "teamOpponent" | "custom";
        topLabel: string;
        sideLabel: string;
        topTeamId?: string | null;
        sideTeamId?: string | null;
      };
      rowNumbers?: number[] | null;
      colNumbers?: number[] | null;
      lockAt?: string | null;
      lockedAt?: string | null;
      frozenAt?: string | null;
      caption: string;
      adminActions: {
        canUnpublish: boolean;
        canUnlock: boolean;
        canRandomize: boolean;
        canClear: boolean;
      };
      customTitle?: string | null;
    };
    squares: {
      squareKey: string;
      row: number;
      col: number;
      ownerKind: "member" | "guest";
      ownerId: string;
      displayName: string;
      initials: string;
      isGuest: boolean;
      isMine: boolean;
    }[];
    events: {
      eventId: string;
      homeTeamId: string;
      awayTeamId: string;
      kickoffAt: string;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      homeScore?: number | null;
      awayScore?: number | null;
      periodLabel?: string | null;
      clockLabel?: string | null;
      roundLabel?: string | null;
    }[];
    selectedEventId?: string | null;
    winners: {
      winnerId: string;
      gridId: string;
      eventId: string;
      labelKey:
        | "q1"
        | "half"
        | "q3"
        | "p1"
        | "p2"
        | "after3"
        | "after5"
        | "after7"
        | "final"
        | "custom";
      label: string;
      source: "auto" | "admin";
      sourceNote: "setAutomatically" | "setByAdmin" | "addedByAdmin";
      squareKey?: string | null;
      topDigit: number;
      sideDigit: number;
      ownerKind?: "member" | "guest" | null;
      ownerId?: string | null;
      displayName?: string | null;
      initials?: string | null;
      isGuest: boolean;
      homeScore: number;
      awayScore: number;
    }[];
    checkpointRows: {
      checkpointKey:
        | "q1"
        | "half"
        | "q3"
        | "p1"
        | "p2"
        | "after3"
        | "after5"
        | "after7"
        | "final";
      label: string;
      winnerIds: string[];
      state: "upcoming" | "waitingForFinal" | "adminSets" | "set";
    }[];
    scoredGameCount: number;
    gameCount: number;
    viewer: {
      canManage: boolean;
      canSeeNumbers: boolean;
      mySquareCount: number;
      maxPerMember?: number | null;
      canTake: boolean;
      takeBlockedReason?:
        "gridClosed" | "limitReached" | "notActiveMember" | null;
    };
    refreshIntervalMs?: number | null;
  };
};

export type typeSquaresGridGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGridGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "gridId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGridGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGridGetBody);
  }

  return async function postSquaresGridGet(
    payload: typeSquaresGridGetBody,
  ): Promise<typeSquaresGridGetOutput200 | typeSquaresGridGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGridGet" failed before calling the network. #bfc1b6f6afba`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#bfc1b6f6afba" },
        },
        data: null,
      } as typeSquaresGridGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/grid-get`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGridGetOutput200 | typeSquaresGridGetOutput400;
  };
}
